module.exports = __webpack_public_path__ + "static/media/wall-large-9.6fb5bc39.jpg";